import axios from "./axios";

export default {
    getCustomersByNITAndNCR(data) {
        // console.log(`getCustomersByNITAndNCR`, data);
        const options = {
            method: "GET",
            url: "managecustomer/getByNITAndNRC",
            headers: { "content-type": "application/json" },
            params: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
    },

    importingWithholdingCertificates(data) {
        const options = {
            method: "POST",
            url: "importingWithholdingCertificates",
            headers: { "content-type": "multipart/form-data" },
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    verifyDuplicatedEntries(value) {
            const options = {
                method: 'GET',
                url: '/importingWithholdingCertificates/verifyDuplicatedEntries',
                headers: { 'content-type': 'application/json' },
                params: value
            };
            return new Promise((resolve, reject) => {
                axios(options)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
}